import axios from 'axios';
import React, { useMemo, useState, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Grid } from 'semantic-ui-react';
import { config } from '../../contexts/UrlContext';
import AuthContext from "../../contexts/AuthContext";


const baseStyle = {
	flex: 1,
	display: 'flex',
	height: "25vh",
	width: "100%",
	cursor: "pointer",
	flexDirection: 'column',
	alignItems: 'center',
	padding: '104px',
	borderWidth: 6,
	borderRadius: 2,
	borderColor: '#eeeeee',
	borderStyle: 'dashed',
	backgroundColor: '#fafafa',
	color: '#bdbdbd',
	outline: 'none',
	transition: 'border .24s ease-in-out'
};

const activeStyle = {
	borderColor: '#2196f3'
};

const acceptStyle = {
	borderColor: '#00e676',
	color: '#00e676',
};

const rejectStyle = {
	borderColor: '#ff1744',
	color: '#ff1744',
};

function StyledDropzone() {

	const { auth } = useContext(AuthContext);

	const [file, setFile] = useState([1]);
	const {
		getRootProps,
		acceptedFiles,
		getInputProps,
		isDragActive,
		isDragAccept,
		isDragReject,
	} = useDropzone({
		accept: ".lic",
		onDrop: acceptedFiles => {
			setFile(acceptedFiles);

			if (acceptedFiles.length !== 0) {
				onClickHandler(acceptedFiles);
			}
		},
		minSize: 0,
		maxSize: 5242880,
		maxFiles: 1,
		multiple: false
	});

	const style = useMemo(() => ({
		...baseStyle,
		...(isDragActive ? activeStyle : {}),
		...(isDragAccept ? acceptStyle : {}),
		...(isDragReject ? acceptStyle : {})
	}), [
		isDragActive,
		isDragReject,
		isDragAccept
	]);

	const acceptedFileItems = acceptedFiles.map(file => (
		<div key={file.path} style={{ fontSize: 'x-large', fontWeight: 'bold' }}>
			{acceptedFiles.length} File(s) Selected, {file.size} Bytes
		</div>
	));

	const onClickHandler = async (acceptedFiles) => {

		try {
			let form = new FormData();

			for (let i = 0; i < acceptedFiles.length; i++) {
				let element = acceptedFiles[i];
				form.append('file', element);
			}

			let response;

			if (!auth || auth === null) {
				response = await axios.post(`${config.baseUrl}/api/ContentManager/SaveLicenseSettings`, form, {
					headers: { 
						'Content-Type': 'multipart/form-data'
					}
				});
			} else {
				let header = {
					'Authorization': `Bearer ${auth.user?.access_token}`,
					'Content-Type': 'multipart/form-data'
				}
				response = await axios.post(`${config.baseUrl}/api/ContentManager/SaveLicenseSettings`, form, {
					headers: header
				});
			}

			toast.success(response.data);
			window.location.reload();
		} catch (error) {
			toast.error("Unable to upload license. Try again");
		}
	}

	return (
		<Grid style={{marginLeft: 10}}>
			<Grid.Row>
				<Grid.Column width={8}>
					<div {...getRootProps({ style })}>
						<input {...getInputProps()} />
						{!isDragActive && acceptedFiles.length === 0 && 'Drag and Drop a new license'}
						{isDragActive && !isDragReject && "Drop a new license to get started!"}
						{isDragReject}
						{!isDragActive && acceptedFiles.length !== 0 && acceptedFileItems}
					</div>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

class UploadLicenseDropzone extends React.Component {

	constructor(props) {
		super(props);

		this.state = {

		};
	}

	render() {

		return (
			<StyledDropzone />
		)
	}
}

export default UploadLicenseDropzone